import { Select } from 'antd'
import { Workarea } from './editVisitApi'
import WorkareaLabel from './WorkareaLabel'

export type Props = {
  disabled?: boolean
  workareas: Workarea[]
  selectedWorkareaId?: number
  onChange: (workareaId: number) => void
  changed?: boolean
}

const getOptions = (workareas: Workarea[]) => {
  return workareas.map(x => <Select.Option key={x.id} value={x.id}>{<WorkareaLabel workarea={x} />}</Select.Option>)
}

const WorkareaSelector = ({ disabled, workareas, selectedWorkareaId, onChange, changed }: Props) => {
  return <Select placeholder="Select a workarea..."
    disabled={disabled}
    popupMatchSelectWidth={false}
    value={selectedWorkareaId}
    onChange={onChange}
    style={{ maxWidth: '180px' }}
    status={changed ? 'warning' : undefined}
  >
    {getOptions(workareas)}
  </Select>
}
export default WorkareaSelector
